// Hook - lista userow ktorych mozna promowac na handlowca.
// GET /api/ui/trader-management/users-to-promote

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type {
  IGetUsersToPromoteParams,
  IGetUsersToPromoteResponse,
} from 'api/types/traderManagement';

const getUsersToPromote = (
  params: IGetUsersToPromoteParams
): Promise<IGetUsersToPromoteResponse> =>
  axios.get('/trader-management/users-to-promote', { params });

export const useGetUsersToPromote = (
  params: IGetUsersToPromoteParams = {},
  options?: UseQueryOptions<IGetUsersToPromoteResponse, IError>
) =>
  useQuery<IGetUsersToPromoteResponse, IError>(
    ['trader-management-users-to-promote', params],
    () => getUsersToPromote(params),
    { keepPreviousData: true, ...(options ?? {}) }
  );
